/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_preview = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The quick brown fox`)
};

const es_cc_preview = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El veloz murciélago hindú`)
};

const de_cc_preview = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der schnelle braune Fuchs`)
};

const nl_cc_preview = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The quick brown fox`)
};

const fr_cc_preview = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portez ce vieux whisky au juge blond qui fume`)
};

const it_cc_preview = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The quick brown fox`)
};

const pt_br2_cc_preview = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A rápida raposa marrom`)
};

const pt_cc_preview = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A rápida raposa castanha`)
};

const ja_cc_preview = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`素早い茶色のキツネ`)
};

const zh_cc_preview = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`敏捷的棕色狐狸`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_preview = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_preview(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_preview", locale)
	if (locale === "en") return en_cc_preview(inputs)
	if (locale === "es") return es_cc_preview(inputs)
	if (locale === "de") return de_cc_preview(inputs)
	if (locale === "nl") return nl_cc_preview(inputs)
	if (locale === "fr") return fr_cc_preview(inputs)
	if (locale === "it") return it_cc_preview(inputs)
	if (locale === "pt-BR") return pt_br2_cc_preview(inputs)
	if (locale === "pt") return pt_cc_preview(inputs)
	if (locale === "ja") return ja_cc_preview(inputs)
	return zh_cc_preview(inputs)
};